<template>
    <div class="projectlist-wrapper">

        <div class="projectlist-list">
            <span class="projectlist-list-hovercard-wrapper">
                <img src="" alt="" class="projectlist-list-hovercard-image">
                <div class="projectlist-list-hovercard-text-wrapper">
                    <p class="projectlist-list-hovercard-text-title">Proyectos de Kraken Labs</p>
                    <p class="projectlist-list-hovercard-text-desc">Descubre algunos de los proyectos de Kraken Labs.</p>
                </div>
            </span>

            <ul class="projectlist-ul" v-for="(ul, i) in projects" :key="i">
                <span>/ . Algunos proyectos de Kraken Labs</span>
                <li class="projectlist-ul-li" :data-excerpt="li.excerpt" :data-projectType="li.projectType"   v-for="(li, j) in ul" :key="j">
                    <router-link class="projectlist-ul-li-a" @mouseleave.native="hideMovingHover" @mousemove.native="imageHover($event, li.img )" :to="{ path: '/projects/' + li.name}">
                        {{ li.name }}
                    </router-link>
                </li>
            </ul>
        </div>

    </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import Router from 'vue-router';
    import gsap, { Power2 } from 'gsap';
    import { works } from '@/data/works.ts';
    import { vw } from '@/utils/deviceDetect';

    Vue.use( Router );

    export default Vue.extend({
        name: 'ProjectsList',
        data() {
            return {
                hoverElement: null,
                hoverImage: null,
                projects: works
            }
        },
        methods: {
            imageHover( event: MouseEvent, image: string ) {
                const hoverElement = document.querySelector('.projectlist-list-hovercard-wrapper') as HTMLDivElement;
                const hoverImage   = document.querySelector('.projectlist-list-hovercard-image') as HTMLImageElement;
                const hoverTitle   = document.querySelector('.projectlist-list-hovercard-text-title') as HTMLDivElement;
                const actualLi     = (event.target as HTMLDivElement).parentElement as HTMLDivElement;
                const hoverDesc    = document.querySelector('.projectlist-list-hovercard-text-desc') as HTMLDivElement;

                hoverImage.src = image;

                hoverTitle.innerHTML = actualLi.getAttribute('data-excerpt') as string;
                hoverDesc.innerHTML  = actualLi.getAttribute('data-projectType') as string;

                this.moveElementToMousePosition( event, hoverElement )

            },
            moveElementToMousePosition( event: MouseEvent, element: HTMLDivElement | HTMLElement ) {
                gsap.to( element, { opacity: 1, top: event.clientY + 'px', left: event.clientX + (element.offsetWidth * 1.3) + 'px', ease: Power2.easeOut})
            },
            setMovingHover() {
                this.$data.hoverElement = document.querySelector('.projectlist-list-hovercard-wrapper') as HTMLDivElement;
                this.$data.hoverImage   = document.querySelector('.projectlist-list-hovercard-image') as HTMLImageElement;
            },
            hideMovingHover() {
                gsap.to( this.$data.hoverElement, {opacity: 0, ease: Power2.easeOut})
            }
        },
        mounted() {
            if( vw > 768 )
                this.setMovingHover();
        }
    })
</script>

<style scoped lang='scss'>
    .projectlist {
        &-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-height: 100%;
            position: relative;
        }

        &-list {
            min-height: 60vh;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 2rem;

            &-hovercard {
                &-text {

                    &-wrapper {
                        min-width: 17rem;
                        padding-left: 1rem;
                        border: 1px solid #fff;
                        border-left: transparent;
                        min-height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        border-radius: 0 8px 8px 0;
                    }

                    &-title {
                        color: #fff;
                        letter-spacing: 1px;
                        font-size: .9rem;
                        padding-right: .6rem;
                    }
                    
                    &-desc {
                        color: rgb(230, 172, 49);
                        font-size: .8rem;
                    }
                }
                &-wrapper {
                    position: fixed;
                    width: 8rem;
                    height: 8rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1;
                    pointer-events: none;
                }

                &-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border: 1px solid #fff;
                    border-radius: 8px 0 0 8px;
                    border-right: transparent;
                }
            }
        }

        

        &-ul {
            width: 100%;
            list-style: none;
            color: #fff;
            margin-bottom: .2rem;

            & span {
                display: block;
                font-size: 1.6rem;
                position: relative;
                width: 100%;
                padding-bottom: 1rem;
                font-size: 1.7rem;
                font-weight: 300;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: .8rem;
                    width: 100%;
                    height: 1px;
                    background-color: #fff;
                }
            }

            &-li {
                padding-left: 2rem;
                margin-bottom: 1.2rem;
                cursor: pointer;
                position: relative;

                &:nth-last-child(1) {
                    margin-bottom: 3rem;
                }

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 0;
                    height: 1px;
                    background-color: #fff;
                    transition: all .25s;
                    pointer-events: none;
                }

                &:hover {
                    &::before {
                        width: 100%;
                    }
                }

                & a {
                    text-decoration: none;
                    color: #fff;
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }

            &:nth-last-child(1) {
                & li {
                    &:nth-last-child(1) {
                        margin-bottom: 0rem;
                    }
                }
            }
        }

        @media SCREEN AND ( min-width: 768px ) {
            &-wrapper {
                flex-direction: row;
            }

            &-list {
                width: 75%;
            }

            &-views {
                width: 50%;
                min-height: 100vh;
            }
            

            &-ul {
                width: 100%;
                list-style: none;
                color: #fff;

                & span {
                    padding-bottom: 1.3rem;
                    font-size: 2.2rem;
                    margin-bottom: 1rem;
                }

                &-li {
                    font-size: 1.7rem;
                    font-weight: 300;
                    letter-spacing: 1px;
                }
            }
        }

        @media SCREEN AND ( min-width: 1800px ) {

            &-list {
                width: 50%;
            }

            &-ul {
                width: 100%;
                list-style: none;
                color: #fff;
                margin-bottom: 5rem;

                & span {
                    font-size: 2.5rem;
                    letter-spacing: 2px;
                }

                &-li {
                    font-size: 1.8rem;
                }
            }
        }
    }
</style>